import React, { Component } from 'react';

import AppBase from './AppBase';

export default class Help extends Component {
  render() {
    return (
      <AppBase title="Help page">
        <p>U heeft hulp nodig..</p>
      </AppBase>
    );
  }
};
